import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ContactsDTO, MyContactsDTO, ShareSurgeonToContactsDTO } from '../Models/Contact.model';
import { CustomCategoryDTO, EquipmentDTO } from '../Models/Equipment.model';
import { CustomProcedureDTO, ProcedureDTO, TemplateDTO, UserProcedureDataDTO, SpecialityImageDTO } from '../Models/Procedure.model';
import { SpecialityDTO } from '../Models/Speciality.model';
import { SurgeonDTO, SurgeonSpecialityDTO } from '../Models/Surgeon.model';
import { Globals } from '../Models/UserProfile.model';
import { ProcedureCompComponent } from '../procedure-comp/procedure-comp.component';
import { ProcedureComponent } from '../procedure/procedure.component';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import {environment} from '../../environments/environment';

declare var swal: any;

@Component({
  selector: 'app-surgeonlist',
  templateUrl: './surgeonlist.component.html',
  styleUrls: ['./surgeonlist.component.scss'],
  providers: [SrubUpService, ProcedureComponent, ProcedureCompComponent],
  encapsulation: ViewEncapsulation.Emulated
})

export class SurgeonlistComponent implements OnInit {
  public baseurl: string = environment.base_url;
  equipmnt: boolean;
  editModeOn: boolean;
  showEquipmentEditingDiv: boolean;
  catgIndex: number;
  equipmntIndex: number;
  surgonEquipmentCat:any=[];
  surgonEquipmentlist:any=[];
  customEquipmentCategories: Array<CustomCategoryDTO>;

  equipmentName: string;
  specification: string;
  quantity: number;
  categoryName: string;
  EquipmentId: string;

  backToAddNote: boolean;
  showSpeciality: number;
  sharedUserInfo: MyContactsDTO;
  myContactsList: Array<MyContactsDTO>;
  contacts: ContactsDTO;
  shareSurgeonToContactsList: Array<ShareSurgeonToContactsDTO>;
  shareSurgeonToContact: ShareSurgeonToContactsDTO;
  shareSurgeonToUserIds: Array<number>;
  selectedSurgeonId: any;
  surgonID: string;
  surgeonToShare: SurgeonDTO;
  imageUploadApiUrlLength: number;
  uploadUrl: string;
  doctorsName: string;
  doctorsEmail: string;
  doctorsPhoneNo: string;
  imagePath: string;
  selectedProcedures: Array<string>;
  specialityId: number;
  specialityName: string;
  specialityProcedures: Array<ProcedureDTO>;
  loginUserId: number;
  public loading = false;

  nextButtonDisabled: boolean;
  surgeonList: Array<SurgeonDTO>;
  procedures: Array<ProcedureDTO>;
  specialities: Array<SpecialityDTO>;
  surgeonSpecialityDetails: Array<SurgeonSpecialityDTO>;
  invisible: number;
  editvisi: number;
  showEditingDiv: number;
  showReadOnlyDiv: number
  iValue: number;
  index: boolean;
  edit: boolean;
  isImpersonateMode: boolean;
  surgeonSpecialityDetail: SurgeonSpecialityDTO;
  tempUrl: Array<string>;
  myHeaders: { [name: string]: any };
  getAdminValues: boolean;


  surgeonObj: SurgeonDTO;
  showSurgeonProcedures: boolean;
  surgeonprocedures: Array<ProcedureDTO>;
  pageIndex: number;
  surgonName:any

  equipmentEditView: boolean;
  detailViewIcon: number;
  showAssignEquipment: boolean;
  selectedProcedureId: any;
  userProcedureData: any;
  fullEquipmentsList: any;
  appUser: any;
  categoryequipments: any[];
  selectedProcedureName: any;
  selectedProcSpeciality: any;
  equipmentcategories: any;
  assignedEquipmentcategories: any;
  procedureNames: Array<CustomProcedureDTO>;
  specialityTempUrl: Array<string>;
  selectedSpecialityProcedure: Array<SurgeonSpecialityDTO>;
  globalSpecialityId: any;
  specialitySurgeon: boolean;
  selectedSpecialityName: string;

  selectedSpecialityId: number;

  specialityImagesList:Array<SpecialityImageDTO>

  imageToShow: string;

  constructor(private _sanitizer: DomSanitizer, private token: Token, private router: Router, private procdure: ProcedureCompComponent, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    Globals.SpecialityName = this.cookieService.get('specialityName');
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
      Globals.SpecialityId = parseInt(this.cookieService.get('specialityId'));
      Globals.SpecialityName = this.cookieService.get('specialityName');
    }
    this.editModeOn = false;
    this.showEquipmentEditingDiv = false;
    this.customEquipmentCategories = new Array<CustomCategoryDTO>();
    this.specialityImagesList=new Array<SpecialityImageDTO>();
    this.surgonName=this.cookieService.get("surgonName");
    if (Globals.SpecialityId == 0) {
      this.specialitySurgeon = false;
    }
    else {
      this.specialitySurgeon = true;
    }
    this.selectedSpecialityId = Globals.SpecialityId;
    this.getAdminValues = false;
    this.myHeaders = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Surgeon List"

    };
    if (Globals.SpecialityId != undefined && Globals.SpecialityId != null && Globals.SpecialityId != 0) {
      this.globalSpecialityId = Globals.SpecialityId;
    }
    this.backToAddNote = false;
    this.pageIndex = 0;

    this.surgeonObj = new SurgeonDTO();
    this.showSurgeonProcedures = false;
    this.surgeonprocedures = new Array<ProcedureDTO>();
    this.tempUrl = new Array<string>();
    this.specialityTempUrl = new Array<string>();

    this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    Globals.LoginUsrId = this.loginUserId;

    this.selectedSpecialityName = Globals.SpecialityName;
    this.uploadUrl = this.baseurl + "api/Speciality/UploadImage?userId=" + this.loginUserId;
    this.specialityId = 0;

    this.procedureNames = new Array<CustomProcedureDTO>();
    this.selectedProcedures = new Array<string>();
    this.surgeonSpecialityDetails = new Array<SurgeonSpecialityDTO>();


    this.selectedSpecialityProcedure = new Array<SurgeonSpecialityDTO>();
    this.index = true;

    this.invisible = 0;
    this.editvisi = 0;

    this.showEditingDiv = -1;
    this.showReadOnlyDiv = -1;
    this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
  }

  ShowImage(index) {
    this.imageToShow = this.surgeonList[index].ImageBase64;
  }

  GetImage(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUserDetails.UserId).subscribe(ab => {
        this.surgeonList.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });
    });
  }

  GetImageBase64(specialityId: number) {
    var speciality = this.specialityImagesList.find(x => x.SpecialityId == specialityId);
    if (speciality != undefined && speciality != null) {
      var imageBase64 = speciality.ImageBase64
      if (imageBase64 != undefined && imageBase64 != null && imageBase64 != "") {
        return imageBase64;
      }
      else {
        return "";
      }
    }
    else {
      return "";
    }
  }
  GetSpecialityImage(imageSrc:Array<SpecialityImageDTO>) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element.ImagePath, 1).subscribe(ab => {
         element.ImageBase64 = "data:image/png;base64," + ab
      });
    });
  }
  GetImageForEquipment(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUserDetails.UserId).subscribe(ab => {
        this.fullEquipmentsList.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });
    });
  }


  OnUploadFinished(response: any) {
    if (response.serverResponse.response.status == "200") {
      this.imagePath = response.serverResponse.response._body;
      this.imagePath = this.imagePath.substring(1, this.imagePath.length - 1);
    }
  }

  navToParent() {
    this.router.navigate(['layout/user-procedure']);
  }

  ShareIt(index) {
    this.surgeonToShare = new SurgeonDTO;
    this.surgeonToShare = this.surgeonList[index];
    this.selectedSurgeonId = this.surgeonToShare.SurgeonId;
  }

  GetContactsInfo() {
    this.shareSurgeonToContactsList = new Array<ShareSurgeonToContactsDTO>();
    this.loading = true;
    this.scrubUpService.GetContactsInfo(this.token, this.loginUserId).subscribe(x => {
      if (x != null && x != undefined) {
        this.contacts = x;
        if (x.MyContacts != null && x.MyContacts != undefined) {
          this.myContactsList = this.contacts.MyContacts;
          this.myContactsList.forEach(element => {
            this.shareSurgeonToContact = new ShareSurgeonToContactsDTO;
            this.shareSurgeonToContact.UserId = element.UserId;
            this.shareSurgeonToContact.Name = element.Name;
            this.shareSurgeonToContact.MobileNumber = element.MobileNumber;
            this.shareSurgeonToContact.Email = element.Email;
            this.shareSurgeonToContact.IsChecked = false;
            this.shareSurgeonToContact.ContactsGroup = element.ContactsGroup;
            this.shareSurgeonToContact.IsGroup = element.IsGroup;
            this.shareSurgeonToContactsList.push(this.shareSurgeonToContact);

          });
        }
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }


  OnBackButtonClickofProcComp() {
    this.pageIndex = 1;
  }


  ShareSurgeon() {
    this.shareSurgeonToUserIds = new Array<number>();
    this.shareSurgeonToContactsList.forEach(element => {
      // if (element.IsChecked) {
      //   this.shareSurgeonToUserIds.push(element.UserId);
      // }

      if (element.IsChecked && element.IsGroup != "true") {
        this.shareSurgeonToUserIds.push(element.UserId);
      }
      else if (element.IsChecked && element.IsGroup == "true") {
        element.ContactsGroup.GroupMembers.forEach(ele => {
          this.shareSurgeonToUserIds.push(ele.UserId);
        });
      }
    });

    this.shareSurgeonToUserIds =  this.shareSurgeonToUserIds.filter( this.onlyUnique );

    if (this.shareSurgeonToUserIds.length > 0) {
      this.loading = true;
      let SharedAtDateTime: string;
      SharedAtDateTime = new Date().toLocaleString();
      this.scrubUpService.ShareSurgeon(this.token, this.shareSurgeonToUserIds, this.selectedSurgeonId, this.loginUserId,SharedAtDateTime).subscribe(x => {
        if (x == "success") {
          swal({
            title: 'Shared with selected contacts.',
            type: "success",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);
        }
        else {

        }
        this.loading = false;
      });
    }
    else { return; }
  }

  ShowSharedByInfo(sharedByUserId,dateTime) {
    let sharedAtDtTime:string;
    sharedAtDtTime = new Date(dateTime).toLocaleString();
    this.sharedUserInfo = new MyContactsDTO();
    this.sharedUserInfo = this.findObjectByKey(this.myContactsList, 'UserId', sharedByUserId);
    if (this.sharedUserInfo != null) {
      swal(
        {
          text: "shared by ...",
          html: '<div class="well"><label style="font-size:18px;">Shared user info...</label><hr><strong style="font-size:18px;">User Name : </strong>' + this.sharedUserInfo.Name + '<br><br>' +
            '<strong style="font-size:18px;">Email_Id : </strong>' + this.sharedUserInfo.Email + '<br><br>' +
            '<strong style="font-size:18px;">Mobile Number : </strong>' + this.sharedUserInfo.MobileNumber +'<br><br><label style="font-size:12px;text-align:left;">'+sharedAtDtTime +'</label></div>'
        }
      ).catch(swal.noop);
    }
    else {
      swal(
        {
          text: "missing contact info"
        }
      ).catch(swal.noop);
    }

  }

  getSurgeonList() {
    let userspecialityId:any=0;
   let doctorFlag=this.cookieService.get("doctorFlag");

   if(doctorFlag=="true")
   {
    userspecialityId = JSON.parse(this.cookieService.get("userSpecialityId"));
   }
    this.loading = true;
    let packageTypesFeatures = JSON.parse(
      this.cookieService.get("PackageTypesFeatures")
    );

    const isPackageDowngraded = packageTypesFeatures.IsPackageDowngraded
      ? packageTypesFeatures.IsPackageDowngraded
      : false;

    const surgeon = JSON.parse(localStorage.getItem("Surgeon"));

    const featureValue = (surgeon && surgeon.FeatureValue) ? surgeon.FeatureValue : 0;
    this.scrubUpService.GetSurgeons(this.token, this.loginUserId,userspecialityId, featureValue, isPackageDowngraded).subscribe(x => {
   //console.log(x['Data']);
      if (x['Status'] == true && x['Data'] != null) {
        this.surgeonList = x['Data'];
      }

      // if (x != null && x != undefined) {
      //   this.surgeonList = x;
      //   if (Globals.SpecialityId != undefined && Globals.SpecialityId != null && Globals.SpecialityId != 0) {
      //     this.surgeonList = this.surgeonList.filter(x => x.SurgeonSpecialities.findIndex(x => x.SpecialityID == Globals.SpecialityId) !== -1);
      //   }
      //   this.surgeonList.forEach(element => {
      //     this.tempUrl.push(element.ImagePath);
      //   });
      //   this.GetImage(this.tempUrl);
      // }

      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  deleteSpecialityDetail(i, j) {
    this.surgeonSpecialityDetails[i].ProcedureNames.splice(j, 1);
  }

  AddSpecialityDetails() {
    if (this.surgeonSpecialityDetails.find(x => x.SpecialityID == this.specialityId) == undefined) {
      this.surgeonSpecialityDetail = new SurgeonSpecialityDTO();
      this.surgeonSpecialityDetail.SpecialityID = this.specialityId;
      this.surgeonSpecialityDetail.SpecialityName = this.specialityName;
      this.surgeonSpecialityDetail.ProcedureNames = this.selectedProcedures;
      this.surgeonSpecialityDetails.push(this.surgeonSpecialityDetail);
    }
    else {
      this.surgeonSpecialityDetails.find(x => x.SpecialityID == this.specialityId).ProcedureNames = this.selectedProcedures;
    }
  }

  ViewSurgeonInfo(surgonId,Name) {

    this.cookieService.set("surgonId",surgonId);
    this.cookieService.set("surgonName",Name);

   // this.surgeonObj = surgeon;
    // if (this.surgeonObj.SurgeonSpecialities != undefined && this.procedures != undefined && this.surgeonObj.SurgeonSpecialities.length > 0 && this.procedures.length > 0) {
    //   console.log(this.surgeonObj.SurgeonSpecialities);
    //   if (Globals.SpecialityId != undefined && Globals.SpecialityId != 0) {
    //     this.surgeonObj.SurgeonSpecialities.forEach(x => {
    //       x.ProcedureNames.forEach(k => {
    //         var procedure = this.procedures.find(y => y.Name == k && y.SpecialityID == x.SpecialityID);
    //         if (procedure.SpecialityID == Globals.SpecialityId) {
    //           if (procedure != null && procedure != undefined) {
    //             this.surgeonprocedures.push(procedure);
    //           }
    //         }
    //       });
    //     });
    //   }
    //   else {
    //     this.surgeonObj.SurgeonSpecialities.forEach(x => {
    //       x.ProcedureNames.forEach(k => {
    //         var procedure = this.procedures.find(y => y.Name == k && y.SpecialityID == x.SpecialityID);
    //         if (procedure != null && procedure != undefined) {
    //           this.surgeonprocedures.push(procedure);
    //         }
    //       })
    //     })
    //   }
    // }
    this.pageIndex = 1;
  }

  OnBackBtnClick() {
    this.showSurgeonProcedures = false;
  }

  OnEditBtnClick() {
    this.showSpeciality = -1;
    this.selectedSpecialityProcedure = [];
    this.procedureNames = [];
    this.pageIndex == 7;
    this.surgeonObj.SurgeonSpecialities.forEach(x => {
      if (x.ProcedureNames.length > 0) {
        x.ProcedureNames.forEach(y => {
          this.procedureNames.push({ SpecialityId: x.SpecialityID, ProcedureName: y });
        })
      }
      this.selectedSpecialityProcedure.push(x);
    });
    this.surgonID = this.surgeonObj.SurgeonId;
    this.doctorsName = this.surgeonObj.Name;
    this.doctorsEmail = this.surgeonObj.Email;
    this.doctorsPhoneNo = this.surgeonObj.MobileNumber;
    this.imagePath = this.surgeonObj.ImagePath;
  }

  AddButtonClick() {
    this.showSpeciality = -1;
    this.surgonID = "";
    this.doctorsName = "";
    this.doctorsEmail = "";
    this.doctorsPhoneNo = "";
    this.imagePath = "";
    this.procedureNames = [];
    this.selectedSpecialityProcedure = [];
    this.pageIndex = 6;
  }

  OnCancelButtonClick() {
    this.pageIndex = 0;
  }

  AddSpecialityProcedure(procedure: ProcedureDTO) {

    var specialityObj = this.selectedSpecialityProcedure.find(x => x.ProcedureNames.includes(procedure.Name) && x.SpecialityID == procedure.SpecialityID);
    if (specialityObj != null && specialityObj != undefined) {
      specialityObj.ProcedureNames.splice(specialityObj.ProcedureNames.findIndex(x => x == procedure.Name), 1);
      this.procedureNames.splice(this.procedureNames.findIndex(x => x.ProcedureName == procedure.Name && x.SpecialityId == procedure.SpecialityID));
    }
    else {
      this.procedureNames.push({ SpecialityId: procedure.SpecialityID, ProcedureName: procedure.Name });
      var speciality = this.selectedSpecialityProcedure.find(x => x.SpecialityID == procedure.SpecialityID);
      if (speciality == null || speciality == undefined) {
        this.selectedSpecialityProcedure.push({ ProcedureNames: [procedure.Name], SpecialityID: procedure.SpecialityID, SpecialityName: procedure.SpecialityName });
      }
      else {
        speciality.ProcedureNames.push(procedure.Name);
      }
    }
  }

  IsProcedureAdded(procedure: ProcedureDTO) {
    var index = this.procedureNames.findIndex(x => x.ProcedureName == procedure.Name && x.SpecialityId == procedure.SpecialityID);
    if (index == -1) {
      return false;
    }
    else {
      return true;
    }
  }

  AddSurgeon() {
    let surgeon: SurgeonDTO;
    surgeon = new SurgeonDTO();
    surgeon.SurgeonId = "";
    surgeon.Name = this.doctorsName;
    surgeon.Email = this.doctorsEmail;
    surgeon.MobileNumber = this.doctorsPhoneNo;
    surgeon.ImagePath = this.imagePath;

    surgeon.SurgeonSpecialities = new Array<SurgeonSpecialityDTO>();
    surgeon.SurgeonSpecialities = this.selectedSpecialityProcedure;

    this.loading = true;
    this.scrubUpService.AddSurgeon(this.token, surgeon, this.loginUserId).subscribe(x => {
      if (x == "success") {
        this.selectedSpecialityProcedure = [];
        this.doctorsName = "";
        this.doctorsEmail = "";
        this.doctorsPhoneNo = "";
        this.imagePath = "";
        this.procedureNames = [];
        this
        swal({
          title: 'Surgeon Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.specialityName = "";
        this.pageIndex = 0;
        this.getSurgeonList();
      }
      else if (x == "exists") {
        swal({
          title: 'Surgeon with these contact details already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }
      else {

      }
      this.loading = false;
    });
  }

   onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }

  specialitySelected(specialityId) {
    this.specialityId = specialityId;
    this.specialityName = this.findObjectByKey(this.specialities, 'ID', specialityId).Name;

    this.specialityProcedures = this.procedures.filter(procedure => procedure.SpecialityID === this.specialityId)
  }

  GetProcedures() {
    // this.loading = true;
    // this.scrubUpService.GetProcedures(this.token, this.loginUserId, this.getAdminValues).subscribe(x => {
    //   if (x != null && x != undefined) {
    //     this.procedures = x;
    //   }
    //   this.loading = false;
    // },
    //   error => {
    //     this.loading = false;
    //   })
  }

  GetSpecialities() {
    this.loading = true;
    this.getAdminValues = true;
    this.scrubUpService.GetSpecialities(this.token, 1, this.getAdminValues).subscribe(x => { // to get specialities based on user id
      if (x['Data'] != null && x ['Status'] == true) {
        this.specialities = x['Data'];
        // if (Globals.SpecialityId != undefined && Globals.SpecialityId != 0) {
        //   this.specialities = this.specialities.filter(x => x.ID == Globals.SpecialityId);
        // }
      //   this.specialities.forEach(element => {
      //       let specialitImageObj:SpecialityImageDTO;
      //       specialitImageObj=new SpecialityImageDTO();
      //       specialitImageObj.SpecialityId=element.ID;
      //       specialitImageObj.ImageBase64="";
      //       specialitImageObj.ImagePath=element.ImagePath;
      //       this.specialityImagesList.push(specialitImageObj);
      //    });
      //  this.GetSpecialityImage(this.specialityImagesList);
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
      this.getAdminValues = false;
  }

  Collapse() {
    this.UserClick(1);
    this.invisible = 1;
  }

  UserClick(btnCount) {
    this.edit = false;
    this.surgonID = "";
    this.doctorsName = "";
    this.doctorsEmail = "";
    this.doctorsPhoneNo = "";
    this.specialityId = 0;
    this.selectedProcedures = [];
    this.surgeonSpecialityDetails = [];
    if (btnCount == 1) {
      this.edit = true;
      this.showEditingDiv = -1;
      this.showReadOnlyDiv = -1;
    }
    if (btnCount == 3) {
      this.edit = false;
      this.invisible = 0;
      this.showEditingDiv = -1;
    }
    if (btnCount == 5) {//eq
      this.equipmnt = false;

      this.showEquipmentEditingDiv = false;
      this.equipmentName = "";
      this.specification = "";
      this.quantity = 0;
      this.categoryName = "";
      this.imagePath = "";
      this.EquipmentId = "";
    }
    if (btnCount == 6) {//eq
      this.equipmnt = false;

      this.showEquipmentEditingDiv = false;
      this.invisible = 0;
      this.equipmentName = "";
      this.specification = "";
      this.quantity = 0;
      this.categoryName = "";
    }
  }

  OnEditButtonClick() {
    this.pageIndex = 7;
  }

  UpdateSurgeon() {
    let surgeon: SurgeonDTO;
    surgeon = new SurgeonDTO();
    surgeon.SurgeonId = this.surgonID;
    surgeon.Name = this.doctorsName;
    surgeon.Email = this.doctorsEmail;
    surgeon.MobileNumber = this.doctorsPhoneNo;
    surgeon.ImagePath = (this.imagePath == this.surgeonObj.ImagePath) ? this.imagePath.slice(this.imageUploadApiUrlLength) : this.imagePath;
    surgeon.SurgeonSpecialities = new Array<SurgeonSpecialityDTO>();
    surgeon.SurgeonSpecialities = this.selectedSpecialityProcedure;

    this.loading = true;
    this.scrubUpService.UpdateSurgeon(this.token, surgeon, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Update Successful',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.specialityName = "";
        this.UserClick(3);
        this.pageIndex = 0;
        this.getSurgeonList();
      }
      else if (x == "exists") {
        swal({
          title: 'Surgeon with these contact details already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }
      else {

      }
      this.loading = false;
    });
  }

  saveAssignEquipmentChanges() {
    this.equipmentEditView = false;
    this.SaveEquipmentsList();
    this.showEditingDiv = -1;
    this.detailViewIcon = -1;
    this.index = true;
    this.showAssignEquipment = false;
  }

  SaveEquipmentsList() {
    let userProcObJ: UserProcedureDataDTO;
    userProcObJ = new UserProcedureDataDTO();
    userProcObJ.SpecialityId = this.specialityId;
    userProcObJ.ProcedureId = this.selectedProcedureId;
    userProcObJ.UserId = Globals.LoginUsrId;
    userProcObJ.Template = new TemplateDTO();
    userProcObJ.Template = this.userProcedureData.Template;
    userProcObJ.Equipments = [];
    userProcObJ.Equipments = this.userProcedureData.Equipments;
    userProcObJ.Equipments = this.fullEquipmentsList.filter(equipment => equipment.IsChecked === true)
    this.loading = true;
    this.scrubUpService.AssignEquipments(this.token, userProcObJ, this.appUser.UserId).subscribe(x => {
      swal({
        title: 'Equipments Saved Successfully',
        type: "success",
        timer: 2000,
        showConfirmButton: false
      }).catch(swal.noop);
      this.loading = false;
    });
  }

  viewEquipmentDetails(index: number, categoryName: string) {
    this.equipmentEditView = false;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
        this.detailViewIcon = -1;
        this.iValue = -1;
      }
      else {
        this.categoryequipments = new Array<EquipmentDTO>();
        this.mapAssignedEquipments();
        this.categoryequipments = this.fullEquipmentsList.filter(equipment => equipment.CategoryName === categoryName);
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.detailViewIcon = index;
        this.iValue = index;
      }
    }
    else {
      this.categoryequipments = new Array<EquipmentDTO>();
      this.mapAssignedEquipments();
      this.categoryequipments = this.fullEquipmentsList.filter(equipment => equipment.CategoryName === categoryName);
      this.showEditingDiv = index;
      this.detailViewIcon = index;
      this.iValue = index;
    }
  }

  getEquipChecklistDetails(specialityId: number, pId: string, categoryId: number) {
    this.selectedProcedureId = pId;
    Globals.PId = pId;
    this.specialityId = specialityId;
    Globals.SpecialityId = specialityId;
    Globals.CategoryId = categoryId;
    var x = this.findObjectByKey(this.procedures, 'ID', this.selectedProcedureId);
    this.selectedProcedureName = x.Name;
    this.selectedProcSpeciality = x.SpecialityName;
    this.fullEquipmentsList = [];
    this.fullEquipmentsList = x.Equipments;

    this.fullEquipmentsList.forEach(element => {
      //element.ImagePath =this.token.webAPIURL+"Speciality/GetUploadedImage?imageName="+element.ImagePath;
      this.tempUrl.push(element.ImagePath);
    });
    this.GetImageForEquipment(this.tempUrl);

    this.getEquipmentList();
  }

  //category list
  getEquipmentCategoryList() {
    this.loading = true;
    this.scrubUpService.GetEquipmentCategoryList(this.token, this.loginUserId).subscribe(x => {
      if (x['Data'] != null && x.Status == true) {
        this.surgonEquipmentCat = x['Data'];
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  //equipment list
  getEquipmentList() {
    this.customEquipmentCategories = [];
    let custEquipment: CustomCategoryDTO;

    let tempEquipments: Array<EquipmentDTO>;
    tempEquipments = new Array<EquipmentDTO>();

    let catg: string;

    this.equipmentcategories.forEach(element => {
      tempEquipments = this.fullEquipmentsList.filter(x => x.CategoryName == element);
      if (tempEquipments.length > 0) {
        custEquipment = new CustomCategoryDTO();
        custEquipment.CategoryName = element;
        custEquipment.Equipments = tempEquipments;
        this.customEquipmentCategories.push(custEquipment);
      }
    });
  }

  OnBackButtonClick() {
    this.pageIndex = 0;
  }

  OnBackButtonEquipments() {
    this.pageIndex = 1;
  }

  getAssignedEquipmentList() {
    this.userProcedureData = new UserProcedureDataDTO;
    this.loading = true;
    this.scrubUpService.GetAssignedEquipmentsList(this.token, this.specialityId).subscribe(x => {
      if (x != null && x != undefined) {
        this.userProcedureData = x;
        this.assignedEquipmentcategories = this.userProcedureData.Equipments;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  mapAssignedEquipments() {
    for (let x = 0; x < this.fullEquipmentsList.length; x++) {
      if (this.assignedEquipmentcategories == null) {
        this.assignedEquipmentcategories = [];
        return;
      }
      for (let y = 0; y < this.assignedEquipmentcategories.length; y++) {
        if (this.fullEquipmentsList[x].ID == this.assignedEquipmentcategories[y].ID) {
          this.fullEquipmentsList[x] = this.assignedEquipmentcategories[y];
        }
      }
    }
  }

  DeleteSurgeon(index) {
    var surgonId = this.surgeonList[index].SurgeonId;
    this.scrubUpService.DeleteSurgeon(this.token, surgonId, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Deleted Successful',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.specialityName = "";
        this.UserClick(3);
        this.getSurgeonList();
      }
      else if (x == "failure") {
        swal({
          title: 'Deletion Failed!!',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }
      else {

      }
      this.loading = false;
    });

  }

  CollapseSpeciality(index: number) {
    if (this.showSpeciality == -1) {
      this.showSpeciality = index;
    }
    else {
      this.showSpeciality = -1;
    }
  }

  CollapseSurgeon(index: number) {
    this.showEditingDiv = -1;
    this.specialityId = 0;
    this.selectedProcedures = [];
    this.editvisi = 1;
    // this.correctiveActionUpdateExists=false;
    if (this.showReadOnlyDiv != -1) {
      if (this.iValue == index) {
        this.showReadOnlyDiv = -1;
      }
      else {
        this.showReadOnlyDiv = -1;
        this.showReadOnlyDiv = index;
        this.iValue = index;
      }
      this.doctorsName = this.surgeonList[index].Name;
      this.doctorsEmail = this.surgeonList[index].Email;
      this.doctorsPhoneNo = this.surgeonList[index].MobileNumber;
      this.imagePath = this.surgeonList[index].ImagePath;
      this.surgeonSpecialityDetails = this.surgeonList[index].SurgeonSpecialities;
      this.edit = false;
    }
    else {
      this.doctorsName = this.surgeonList[index].Name;
      this.doctorsEmail = this.surgeonList[index].Email;
      this.doctorsPhoneNo = this.surgeonList[index].MobileNumber;
      this.imagePath = this.surgeonList[index].ImagePath;
      this.surgeonSpecialityDetails = this.surgeonList[index].SurgeonSpecialities;
      this.showReadOnlyDiv = index;
      this.iValue = index;
      this.edit = false;
    }
  }

  EditSurgeon(index: number) {
    this.showReadOnlyDiv = -1;
    this.specialityId = 0;
    this.selectedProcedures = [];
    this.editvisi = 1;
    // this.correctiveActionUpdateExists=false;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      this.surgonID = this.surgeonList[index].SurgeonId;
      this.doctorsName = this.surgeonList[index].Name;
      this.doctorsEmail = this.surgeonList[index].Email;
      this.doctorsPhoneNo = this.surgeonList[index].MobileNumber;
      this.imagePath = this.surgeonList[index].ImagePath;
      this.surgeonSpecialityDetails = this.surgeonList[index].SurgeonSpecialities;
      this.edit = false;
    }
    else {
      this.surgonID = this.surgeonList[index].SurgeonId;
      this.doctorsName = this.surgeonList[index].Name;
      this.doctorsEmail = this.surgeonList[index].Email;
      this.doctorsPhoneNo = this.surgeonList[index].MobileNumber;
      this.imagePath = this.surgeonList[index].ImagePath;
      this.surgeonSpecialityDetails = this.surgeonList[index].SurgeonSpecialities;
      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }
  }

  ngOnInit() {

    this.getSurgeonList();
    this.GetSpecialities();
    this.GetProcedures();
    this.GetContactsInfo();
    this.getEquipmentCategoryList();
  }

  addEquipmentbtn() {
    // this.UserClick(6);
    this.equipmnt = true;
  }

  equipEditModeOn() {
    this.editModeOn = this.editModeOn == true ? false : true;
    this.showEquipmentEditingDiv = false;
    this.equipmnt = false;
  }

  editEquipment(catgIndx, equipIndx) {
    this.catgIndex = catgIndx;
    this.equipmntIndex = equipIndx;
    let toEditEquipment: EquipmentDTO;
    toEditEquipment = new EquipmentDTO();
    toEditEquipment = this.customEquipmentCategories[catgIndx].Equipments[equipIndx];

    // this.correctiveActionUpdateExists=false;

    this.categoryName = toEditEquipment.CategoryName;
    this.equipmentName = toEditEquipment.Name;
    this.specification = toEditEquipment.Specification;
    this.quantity = toEditEquipment.Quantity;
    this.EquipmentId = toEditEquipment.ID;
    this.imagePath = toEditEquipment.ImagePath;
    this.showEquipmentEditingDiv = true;
    this.equipmnt = true;
  }

  AddUserEquipment() {
    let equipment: EquipmentDTO;
    equipment = new EquipmentDTO();
    equipment.Name = this.equipmentName;
    equipment.CategoryName = this.categoryName;
    equipment.ImagePath = this.imagePath;
    equipment.Specification = this.specification;
    equipment.Quantity = this.quantity;
    equipment.ID = "";
    this.loading = true;

    // , Globals.SpecialityId, Globals.PId, this.appUser.UserId
    this.scrubUpService.AddUserEquipment(this.token, equipment).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Equipment Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.UserClick(5);
        this.getEquipChecklistDetails(Globals.SpecialityId, Globals.PId, Globals.CategoryId);
        this.equipmentName = "";
        this.specification = "";
        this.quantity = null;
      }
      else {

      }
      this.loading = false;
    });
  }

  UpdateUserEquipment() {
    this.equipmnt = true;
    let equipment: EquipmentDTO;
    equipment = new EquipmentDTO();
    equipment.ID = this.EquipmentId;
    equipment.Specification = this.specification;
    equipment.Quantity = this.quantity;
    equipment.ImagePath = this.imagePath;
    equipment.Name = this.equipmentName;

    equipment.CategoryName = this.categoryName;

    this.loading = true;

    this.scrubUpService.UpdateUserEquipment(this.token, equipment, Globals.SpecialityId, Globals.PId, this.appUser.UserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Update Successful',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

        this.UserClick(5);
        this.GetProcedures();
        this.getEquipChecklistDetails(Globals.SpecialityId, Globals.PId, Globals.CategoryId);
      }
      else {

      }
      this.loading = false;
    });
  }

  getEquipmentDetailBySurgon(spId,surgonId)
  {

    this.scrubUpService.SurgeonEquipmentsListByUserProcedureID(this.token,spId,surgonId).subscribe(x => {

       if (x['Data'] != null && x.Status == true) {
        this.surgonEquipmentlist = x['Data'];
         for(var j=0;j<this.surgonEquipmentCat.length;j++)
         {
           let doesexist=false;
           for(var i=0;i<this.surgonEquipmentlist.length;i++)
           {

             if(this.surgonEquipmentCat[j]['ECID']==this.surgonEquipmentlist[i]['ECID'])
             {
               doesexist=true;
             }
             if(doesexist)
             {
              //console.log(this.surgonEquipmentlist[i]['SurgeonEquipmentList']);
               this.surgonEquipmentCat[i]['surgonEquipmentList']=this.surgonEquipmentlist[i]['SurgeonEquipmentList'];
             }
           }

         }

       }
       this.loading = false;
     },
       error => {
         this.loading = false;
       })

// this.scrubUpService.GetEquipmentCategoryList(this.token,this.loginUserId).subscribe(x => {
//    //console.log(x);
//     if (x['Data'] != null && x.Status == true) {
//       this.surgonEquipmentCat = x['Data'];


//     }
//     this.loading = false;
//   },
//     error => {
//       this.loading = false;
//     })


    //this.customEquipmentCategories=[];
  }
  ngOnDestroy(){

    this.cookieService.delete("doctorFlag");
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/surgeonlist/surgeonlist.component.ts